import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { OrderLine } from '../../../../../../data/models/transaction/op/outbound/order';
import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';
import { EditCustomerAddressModel } from 'app/views/pages/transaction/op/outbound/order/order-entry/fill-order/fill-order.component';

@Injectable()
export class CustomerAddressService {
    constructor(private http: AuthHttp) { }

    getCustomerAddressesWithCustomerNameByOwner(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'CustomerAddress/GetCustomerAddressesWithCustomerNameByOwner', options)
            .map((response: Response) => response.json());
    }

    save(model: EditCustomerAddressModel) {
        return this.http.post(AppSettings.apiEndpoint + "CustomerAddress/Save", model)
            .map((response: Response) => response.json());
    }

    delete(ownerCode: string, customerCode: string, addressNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);
        params.set('customerCode', customerCode);
        params.set('addressNo', addressNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.delete(AppSettings.apiEndpoint + 'CustomerAddress/Delete', options)
            .map((response: Response) => response.json());
    }

    deleteCustomerUserAuth(customerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('customerCode', customerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.delete(AppSettings.apiEndpoint + 'CustomerAddress/DeleteCustomerUserAuth', options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/customer-address.service.ts